import axios from 'axios';

interface TestPromptRequest {
  prompt: string;
  model: string;
  variables: { [key: string]: string };
}

interface TestPromptResponse {
  result: string;
}

// OpenAI API 직접 호출 버전
export const testPromptWithOpenAI = async ({ prompt, model, variables }: TestPromptRequest): Promise<TestPromptResponse> => {
  // 변수 치환
  let processedPrompt = prompt;
  Object.entries(variables).forEach(([key, value]) => {
    processedPrompt = processedPrompt.replace(new RegExp(`\\$\\{${key}\\}`, 'g'), value);
  });

  try {
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions',
      {
        model: model,
        messages: [
          {
            role: 'system',
            content: '당신은 전문 사주/운세 상담사입니다. 친절하고 전문적으로 답변해주세요.'
          },
          {
            role: 'user',
            content: processedPrompt
          }
        ],
        temperature: 0.7,
        max_tokens: 1000
      },
      {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return {
      result: response.data.choices[0].message.content
    };
  } catch (error) {
    console.error('OpenAI API Error:', error);
    throw new Error('프롬프트 테스트 중 오류가 발생했습니다.');
  }
};

// 백엔드 API를 통한 버전 (추천)
export const testPromptWithBackend = async ({ prompt, model, variables }: TestPromptRequest): Promise<TestPromptResponse> => {
  // 변수 치환
  let processedPrompt = prompt;
  Object.entries(variables).forEach(([key, value]) => {
    processedPrompt = processedPrompt.replace(new RegExp(`\\$\\{${key}\\}`, 'g'), value);
  });

  try {
    // 기존 axios 인스턴스 사용 (JWT 토큰 자동 포함)
    const response = await axios.post('/api/prompt/test', {
      prompt: processedPrompt,
      model: model
    });

    return {
      result: response.data.result
    };
  } catch (error) {
    console.error('Prompt Test API Error:', error);
    throw new Error('프롬프트 테스트 중 오류가 발생했습니다.');
  }
};